var _defs, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgLogoIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 188.43281 188.43281"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "LogoIconGradient",
  x1: 171.477,
  y1: 507.316,
  x2: 208.972,
  y2: 469.819,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#36a7cd"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#36a7cd",
  stopOpacity: 0
})))), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M144.213 22.11l-20.044-8.545h-20.014l12.915 5.56-4.097 2.986 4.097 2.986-12.915 5.556h20.014zm0 72.105c0 27.613-22.382 49.995-49.993 49.995V44.222c27.611 0 49.993 22.382 49.993 49.993m-50.569 76.004c-41.908 0-76.01-34.097-76.01-76.004s34.102-76.004 76.01-76.004c.194 0 .383.028.576.057V.001C42.183.001 0 42.185 0 94.215s42.182 94.218 94.22 94.218v-18.271c-.193.027-.382.057-.576.057"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#LogoIconGradient)",
  d: "M171.477 507.316c0 20.708 16.788 37.495 37.495 37.495v13.687c-.145-.021-.286-.044-.432-.044-28.2 0-51.141-22.941-51.141-51.138s22.941-51.137 51.141-51.137a2.54 2.54 0 0 0 .432-.045v13.686c-20.707 0-37.495 16.787-37.495 37.496",
  transform: "matrix(1.333333 0 0 -1.333333 -184.40983 770.63564)"
})));
export default SvgLogoIcon;